interface GuidedSkipConfirmModalProps {
  onCancel: () => void;
  onConfirm: () => void;
}

export function GuidedSkipConfirmModal({ onCancel, onConfirm }: GuidedSkipConfirmModalProps) {
  return (
    <div className="modal-backdrop guided-skip-backdrop" role="presentation" onClick={onCancel}>
      <section className="confirm-sheet guided-skip-sheet" role="dialog" aria-modal="true" aria-labelledby="guided-skip-title" onClick={(event) => event.stopPropagation()}>
        <div className="sheet-handle" />
        <header className="confirm-header">
          <div>
            <span className="eyebrow">学习提醒</span>
            <h2 id="guided-skip-title">确定要跳过引导吗？</h2>
            <p>引导会帮助你理解融资、航线规划、财务指标和经营规则。</p>
          </div>
          <button className="icon-button" onClick={onCancel} aria-label="取消">×</button>
        </header>
        <div className="guided-skip-warning">
          <strong>跳过后可能错过关键经营信息</strong>
          <span>只有熟悉这类经营游戏的老手才建议跳过。之后仍可在运营顾问中自行查看规则。</span>
        </div>
        <div className="confirm-actions guided-skip-actions">
          <button className="secondary-action" onClick={onCancel}>继续学习</button>
          <button className="primary-button danger" onClick={onConfirm}>确认跳过引导</button>
        </div>
      </section>
    </div>
  );
}
